<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { Vue3Marquee } from 'vue3-marquee'
import { useAppStore } from '@/store/modules/app'

const appStore = useAppStore()
const { showTopNotice } = storeToRefs(appStore)
const topNoticeContent = computed(() => appStore.getUpdateNoticeContent())

function closeNotice() {
  appStore.setShowTopNotice(false)
}
</script>

<template>
  <transition name="fade">
    <div v-if="showTopNotice" class="mx-4 h-100% flex items-center overflow-hidden" data-testid="version-notice">
      <div class="h-30px flex flex-1 items-center overflow-hidden rounded-md bg-[#f2f2f2]">
        <svg-icon name="amplifier" mx-2 size="16px" color="#606266" />
        <div class="flex-1 overflow-hidden">
          <Vue3Marquee
            :pauseOnHover="true"
            :speed="50"
            class="whitespace-nowrap text-size-14px color-[#606266]"
            style="height: 30px; line-height: 30px;"
          >
            {{ topNoticeContent }}
          </Vue3Marquee>
        </div>
        <el-icon class="mx-1 mt-1 cursor-pointer self-start" size="18" color="#606266" @click="closeNotice" data-testid="version-notice-close-button">
          <Close />
        </el-icon>
      </div>
    </div>
  </transition>
</template>
